<template>
  <div class="container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_sign_up_1_single_country_activate_free_trial }}</span>
          </div>
          <div class="signup-form">
            <br/><br/>

            <form action="">
              <input
                  v-for="registerButton in registerButtonList"
                  :key="registerButton.type"
                  :value="getTranslations[registerButton.text]"
                  class="one_time btn btn--medium btn--main"
                  type="submit"
                  @click.prevent="handleSubmit(registerButton.type)"
              />

              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </div>

              <div class="form-group form-group--mobile">
                <span class="form-group__feedback reg_notice" v-if="showDisclaimer()">* {{
                    getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer')
                  }}</span>
                <ul class="alter_flow_list form-group__feedback reg_notice">
                  <li v-for="(key, index) in disclaimers"
                      v-if="getTranslations[key]"
                      :key="index">
                    {{ getTranslations[key] }}
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <simplify-registration
      v-if="simpleRegistrationModalConfig.open"
      :text-key="simpleRegistrationModalConfig.textKey"
      @close="handleCloseSimpleRegistrationModal"
    ></simplify-registration>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import SimplifyRegistration from '../../home/modals/flow/SimplifyRegistration'
import subscriptionMixin, {
  subscriptionOperationEnum,
  subscriptionTypeEnum
} from '../../../common/mixins/subscription'

export default {
  name: 'RegisterViaSms',
  components: {SimplifyRegistration},
  mixins: [subscriptionMixin],
  data () {
    return {
      registerButtonList: [
        {type: subscriptionTypeEnum.DAILY, text: 'visitor_sign_up_1_single_placeholder_daily_subscription'},
        {type: subscriptionTypeEnum.ONE_TIME, text: 'visitor_sign_up_1_single_placeholder_one_time_subscription'}
      ],
      simpleRegistrationModalConfig: {open: false, textKey: undefined},
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
  },
  methods: {
    showDisclaimer () {
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer')
    },
    handleSubmit (subscriptionType) {
      this.subscriptionMixinLaunchAction(
        subscriptionOperationEnum.REGISTER,
        subscriptionType,
        value => {
          this.simpleRegistrationModalConfig.open = true
          this.simpleRegistrationModalConfig.textKey = value
        }
      )
    },
    handleCloseSimpleRegistrationModal () {
      this.simpleRegistrationModalConfig.open = false
      this.simpleRegistrationModalConfig.textKey = undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/RegisterViaSms.vue